// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"1c897222","145":"e0c6dd6a","270":"bbb8459c","284":"2a5bdc09","423":"ddb2478d","749":"55dae068","787":"ed87aa52","922":"1c668523"}[chunkId] + ".chunk.js";
};